'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultUri = exports.createApolloClient = undefined;

var _apolloClient = require('apollo-client');

var _apolloClient2 = _interopRequireDefault(_apolloClient);

var _apolloLink = require('apollo-link');

var _apolloCacheInmemory = require('apollo-cache-inmemory');

var _apolloUploadClient = require('apollo-upload-client');

var _utils = require('@quid-private/utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultUri = '/api/v2/graphql'; // Instantiate a ApolloClient instance providing uri, cache and authentication
//Should be called when token is valid.
//Use function isTokenValid from token.js to evaluate the status of it.
//If the token is valid you can create Apollo Client.

function createApolloClient() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$httpLink = options.httpLink;
  _options$httpLink = _options$httpLink === undefined ? {} : _options$httpLink;
  var _options$httpLink$uri = _options$httpLink.uri,
      uri = _options$httpLink$uri === undefined ? defaultUri : _options$httpLink$uri,
      _options$cache = options.cache,
      cacheOptions = _options$cache === undefined ? {} : _options$cache;
  var token = options.token || new _utils.Token();
  var contextLink = new _apolloLink.ApolloLink(function (operation, forward) {
    var authHeader = token.getAuthHeader();

    if (authHeader) {
      operation.setContext({
        headers: authHeader
      });
    }

    return forward(operation);
  });
  var uploadLink = (0, _apolloUploadClient.createUploadLink)({
    uri: uri,
    credentials: 'include'
  });
  var defaultLink = [contextLink, uploadLink];

  var link = _apolloLink.ApolloLink.from(options.link ? options.link(defaultLink) : defaultLink);

  var cache = new _apolloCacheInmemory.InMemoryCache(cacheOptions).restore(window.__APOLLO_STATE__);
  return new _apolloClient2.default({
    link: link,
    cache: cache
  });
}

exports.createApolloClient = createApolloClient;
exports.defaultUri = defaultUri;